import { useEffect, useRef, useState } from "react";
import { MoreVertical } from "react-feather";
import "./style.css";

interface AnchoredDropdownProps {
    trigger?: React.ReactNode;
    children: React.ReactNode;
    menuClassName?: string;
    triggerClassName?: string;
}

export default function AnchoredDropdown({ trigger, children, menuClassName, triggerClassName }: AnchoredDropdownProps) {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!open) return;
        const handleOutside = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleOutside);
        return () => document.removeEventListener("mousedown", handleOutside);
    }, [open]);

    return (
        <div
            ref={ref}
            className="anchored-dropdown-wrap"
            onPointerDownCapture={(e) => e.stopPropagation()}
            onTouchStartCapture={(e) => e.stopPropagation()}
        >
            <button
                type="button"
                className={`anchored-dropdown-trigger ${triggerClassName ?? ""}`}
                onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
            >
                {trigger ?? <MoreVertical size={19} />}
            </button>
            {open && (
                <div className={`anchored-dropdown-menu ${menuClassName ?? ""}`} onClick={() => setOpen(false)}>
                    {children}
                </div>
            )}
        </div>
    );
}

interface DropdownItemProps {
    icon?: React.ReactNode;
    danger?: boolean;
    onClick: () => void;
    children: React.ReactNode;
}

export function DropdownItem({ icon, danger, onClick, children }: DropdownItemProps) {
    return (
        <button
            type="button"
            className={`anchored-dropdown-item ${danger ? "anchored-dropdown-item--danger" : ""}`}
            onClick={onClick}
        >
            {icon}{children}
        </button>
    );
}
